module.exports = __webpack_public_path__ + "static/avatar_6-bca3b40528bd3451e3ad25a20a8878fb.png";